import { useSortable } from '@dnd-kit/sortable'
import { forwardRef } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;

  min-width: 20px;
  cursor: pointer;
`

const Line = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${({ theme }) => theme.color.neutral.color5};
`

const Handler = forwardRef<
  HTMLDivElement,
  { id: string | number; className?: string }
>(({ id, className }, ref) => {
  const { setActivatorNodeRef, listeners, attributes } = useSortable({ id })

  if (ref) {
    if (typeof ref === 'object') {
      setActivatorNodeRef(ref?.current)
    }
  }

  return (
    <Wrapper {...attributes} {...listeners} className={className} ref={ref}>
      <Line />
      <Line />
    </Wrapper>
  )
})

export default Handler
